import { Props as AnswerProps } from '../..'

const TrueFalse = ({ answer }: AnswerProps) => {
  return <div>{answer ? 'VERO' : 'FALSO'}</div>
}

export default TrueFalse
